import { ChangeEvent } from 'react';
import { Field, EventWithDataHandler } from 'redux-form';
import { CHECKOUT_CONTACT_MESSAGE_LENGTH, normalizeMessage } from 'views/CheckoutPage/validation';
import { checkoutForm } from 'views/CheckoutPage/selector';
import connect from 'components/Shared/connect';
import { Button } from 'components/Button';
import { rm } from 'utils';
import { useToggle } from 'hooks';
import styles from './leaveMessage.scss';

const TEXT_AREA_SIZE = 4;

interface OwnProps {
  className?: string;
  onBlur: EventWithDataHandler<ChangeEvent>;
}

export const LeaveMessage = ({ className, onBlur }: OwnProps) => {
  const [isOpen, toggleIsOpen] = useToggle();

  return (
    <div className={className}>
      {isOpen ? <MessageField onBlur={onBlur} /> : <MessageButton onClick={toggleIsOpen} />}
    </div>
  );
};

interface MessageField {
  onBlur: EventWithDataHandler<React.FocusEvent<Element>>;
}
const MessageField = ({ onBlur }: MessageField) => (
  <>
    <label htmlFor="address.message">
      <strong>{rm('checkout_contact_message_disclamer_title')}</strong>
      <span>&nbsp;({rm('checkout_contact_message_disclamer_body')})</span>
    </label>
    <Field
      id="address.message"
      name="message"
      normalize={normalizeMessage}
      className={styles.text}
      rows={TEXT_AREA_SIZE}
      component="textarea"
      onBlur={onBlur}
      autoFocus
    />
    <LengthCounter />
  </>
);

interface StateProps {
  message: string;
}
interface MergedProps {
  length: number;
}
const LengthCounter = connect<MergedProps, Record<string, unknown>, StateProps>(
  state => ({
    message: checkoutForm(state, 'address.message') as string
  }),
  undefined,
  ({ message = '' }, dispatch, props) => ({
    ...dispatch,
    ...props,
    length: message.length
  })
)(({ length }: MergedProps) => (
  <div className={styles.length}>
    ({length}/{CHECKOUT_CONTACT_MESSAGE_LENGTH})
  </div>
));

interface MessageButton {
  onClick: () => void;
}
const MessageButton = ({ onClick }: MessageButton) => (
  <Button appearance="link" onClick={onClick} type="button">
    {rm('checkout_message_button')}
  </Button>
);
